(function () {
  'use strict';

  var EXCLUDE_KEYWORDS = [
    'stampe', 'giapponesi', 'contemporanei', 'mostre', 'acquisizioni',
    'tutte', 'vasi', 'sculture', 'frontpage', 'natale', 'primavera',
    'astrattismo', 'spazialismo', 'optical', 'informale', 'catalogo',
    'novita', 'selezione', 'evidenza'
  ];

  function getArtistHandles() {
    var el = document.getElementById('artist-collection-handles');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; }
    catch (e) { return []; }
  }

  function isArtist(collection, artistHandles) {
    if (artistHandles.length > 0) {
      return artistHandles.indexOf(collection.handle) !== -1;
    }
    var h = collection.handle.toLowerCase();
    return !EXCLUDE_KEYWORDS.some(function (k) { return h.indexOf(k) !== -1; });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function formatPrice(price) {
    if (typeof price === 'string') return price;
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(price / 100);
  }

  function PredictiveSearch() {
    this.input      = document.querySelector('[data-predictive-search-input]');
    this.container  = document.querySelector('[data-predictive-search]');
    this.results    = document.querySelector('[data-predictive-search-results]');
    this.artists    = document.querySelector('[data-predictive-search-artists]');
    this.products   = document.querySelector('[data-predictive-search-products]');
    this.noResults  = document.querySelector('[data-predictive-search-no-results]');
    this.viewAll    = document.querySelector('[data-predictive-search-view-all]');
    this.loading    = document.querySelector('[data-predictive-search-loading]');
    this.debounce   = null;
    this.abort      = null;

    if (!this.input) return;
    this.bind();
  }

  PredictiveSearch.prototype.bind = function () {
    var self = this;

    this.input.addEventListener('input', function (e) {
      var q = e.target.value.trim();
      clearTimeout(self.debounce);
      if (self.abort) { self.abort.abort(); }
      if (q.length < 2) { self.hide(); return; }
      self.debounce = setTimeout(function () { self.search(q); }, 300);
    });

    this.input.addEventListener('focus', function () {
      var q = self.input.value.trim();
      if (q.length >= 2 && self.results && !self.results.hidden) self.showResults();
    });

    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.hide(); self.input.blur(); }
    });

    document.addEventListener('click', function (e) {
      if (self.container && !self.container.contains(e.target)) self.hide();
    });
  };

  PredictiveSearch.prototype.search = function (query) {
    var self = this;
    this.showLoading();

    this.abort = new AbortController();
    var timeout = setTimeout(function () { self.abort.abort(); }, 5000);

    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection&resources[limit]=10',
      { signal: this.abort.signal }
    )
      .then(function (res) {
        clearTimeout(timeout);
        if (!res.ok) throw new Error('fetch error');
        return res.json();
      })
      .then(function (data) {
        var r = (data.resources && data.resources.results) || {};
        self.render(r.collections || [], r.products || [], query);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') { self.hideLoading(); }
      });
  };

  PredictiveSearch.prototype.render = function (collections, products, query) {
    this.hideLoading();

    var handles = getArtistHandles();
    var artists = collections.filter(function (c) { return isArtist(c, handles); });

    if (!artists.length && !products.length) {
      this.showNoResults(query);
      return;
    }

    // Artisti
    if (artists.length) {
      var artistList = this.artists.querySelector('.predictive-search__artists-list');
      artistList.innerHTML = artists.map(function (a) {
        var img = (a.featured_image && a.featured_image.url)
          ? '<img src="' + a.featured_image.url + '" alt="" class="predictive-search__artist-image" width="22" height="22">'
          : '';
        return '<li><a href="' + a.url + '" class="predictive-search__artist-item" role="option">' +
          img + '<span>' + escapeHtml(a.title) + '</span></a></li>';
      }).join('');
      this.artists.hidden = false;
    } else {
      this.artists.hidden = true;
    }

    // Opere
    if (products.length) {
      var productList = this.products.querySelector('.predictive-search__products-list');
      productList.innerHTML = products.map(function (p) {
        var img = p.image
          ? '<img src="' + p.image + '" alt="" class="predictive-search__product-image" width="56" height="56" loading="lazy">'
          : '<div class="predictive-search__product-image"></div>';
        return '<li><a href="' + p.url + '" class="predictive-search__product-item" role="option">' +
          img +
          '<div class="predictive-search__product-info">' +
            '<p class="predictive-search__product-title">' + escapeHtml(p.title) + '</p>' +
            '<p class="predictive-search__product-artist">' + escapeHtml(p.vendor || '') + '</p>' +
          '</div>' +
          '<span class="predictive-search__product-price">' + formatPrice(p.price) + '</span>' +
          '</a></li>';
      }).join('');
      this.products.hidden = false;
    } else {
      this.products.hidden = true;
    }

    // Vedi tutti
    var link = this.viewAll && this.viewAll.querySelector('a');
    if (link) link.href = '/search?q=' + encodeURIComponent(query) + '&type=product,collection';
    if (this.viewAll) this.viewAll.hidden = false;
    if (this.noResults) this.noResults.hidden = true;

    this.showResults();
  };

  PredictiveSearch.prototype.showNoResults = function (query) {
    if (this.artists) this.artists.hidden = true;
    if (this.products) this.products.hidden = true;
    if (this.viewAll) this.viewAll.hidden = true;
    var span = this.noResults && this.noResults.querySelector('[data-predictive-search-query]');
    if (span) span.textContent = query;
    if (this.noResults) this.noResults.hidden = false;
    this.showResults();
  };

  PredictiveSearch.prototype.showResults = function () {
    if (this.results) this.results.hidden = false;
    if (this.loading) this.loading.hidden = true;
  };

  PredictiveSearch.prototype.hide = function () {
    if (this.results) this.results.hidden = true;
    if (this.loading) this.loading.hidden = true;
  };

  PredictiveSearch.prototype.showLoading = function () {
    if (this.results) this.results.hidden = true;
    if (this.loading) this.loading.hidden = false;
  };

  PredictiveSearch.prototype.hideLoading = function () {
    if (this.loading) this.loading.hidden = true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { new PredictiveSearch(); });
  } else {
    new PredictiveSearch();
  }

})();